import { render, staticRenderFns } from "./Opengraph.vue?vue&type=template&id=e3ddf020&scoped=true&"
import script from "./Opengraph.vue?vue&type=script&lang=js&"
export * from "./Opengraph.vue?vue&type=script&lang=js&"
import style0 from "./Opengraph.vue?vue&type=style&index=0&id=e3ddf020&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ddf020",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
